import { Pipe, PipeTransform } from '@angular/core';
import { EventGuest } from '../models/events/guests/event-guest.model';
import { Person } from '../models/people/people/person.model';
import { EventGuestDetails } from '../models/events/guests/event-guest-details.model';

@Pipe({ name: 'fullname' })
export class FullnamePipe implements PipeTransform {

  transform(value: EventGuest | Person | EventGuestDetails | null | undefined, nameFirst: boolean = false): string {
    // Handle null/undefined values gracefully
    if (!value) {
      return '';
    }

    const name = value.name ?? '';
    const surname = value.surname ?? '';
    const lastname = value.lastname ?? '';

    if (nameFirst) {
      return [name, surname, lastname].filter(Boolean).join(' ');
    } else {
      const surnameLast = [surname, lastname].filter(Boolean).join(' ');
      return surnameLast ? `${surnameLast}, ${name}` : name;
    }
  }

}
